module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEyIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC41IDVDMTAuNSA1IDYuNSAwLjk5OTk5OSA2IDAuOTk5OTk5QzUuNSAwLjk5OTk5OSAxLjUgNSAxLjUgNSIgc3Ryb2tlPSIjMjIyNjI4IiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/arrowup.svg
// module id = QUae
// module chunks = 1